import { render, staticRenderFns } from "./RegisteredVisits.vue?vue&type=template&id=6d4ffb9a&"
import script from "./RegisteredVisits.vue?vue&type=script&lang=js&"
export * from "./RegisteredVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports